import { combineReducers } from "redux";
import coinDataReducer from "./coinDataReducer";
import loaderReducer from "./loaderReducer";
import modeReducer from "./modeReducer";
export default combineReducers({
  coinData: coinDataReducer,
  Loader: loaderReducer,
  mode: modeReducer,
});
